import { ColumnsType } from 'antd/lib/table'
import renderDate from '../../../../../helpers/tables/render-date'
import Machine from '../../../../../types/api/machine'
import RewindJob from '../../../../../types/api/rewind-job'
import ShipmentPosition from '../../../../../types/api/shipment-position'
import { MaterialColumnCell } from '../../../flexo/components/cells/material-column-cell'
import { getShipmentFloods } from '../../helpers/get-shipment-floods'
import PrintEndTimeCell from '../cells/print-end-time-cell'
import RewindCopiesCell from '../cells/rewind-copies-cell'
import RewindJobNumberCell from '../cells/rewind-job-number-cell'
import ActionsCell from './components/actions-cell'

export const getColumns = (machines: Machine[]): ColumnsType<RewindJob> => [
    {
        dataIndex: 'id',
        title: 'Номер перемотки',
        width: 70,
        render: (_value, record) => <RewindJobNumberCell rewindJob={record} />,
    },
    {
        dataIndex: ['shipment', 'print_job', 'id'],
        title: 'Номер печати',
        width: 90,
        render: (_value, record) => record.shipment?.print_job?.id || '—',
    },
    {
        dataIndex: ['rewind_job', 'shipment', 'id'],
        title: 'Номер отгрузки',
        width: 95,
        render: (_value, record) => record?.shipment?.id || '—',
    },
    {
        dataIndex: ['shipment', 'clientDeliveryDate'],
        title: 'Дата поставки',
        width: 95,
        render: (_value, record) => {
            const clientDeliveryDate = record.shipment?.clientDeliveryDate

            return clientDeliveryDate ? renderDate(clientDeliveryDate) : '—'
        },
    },
    {
        dataIndex: ['shipment', 'client', 'name'],
        title: 'Заказчик',
        render: (_value, record) => record.shipment?.client?.name || '—',
    },
    {
        dataIndex: ['shipment', 'shipment_positions'],
        title: 'Тираж',
        width: 90,
        render: (_value: ShipmentPosition[], record) => <RewindCopiesCell rewindJob={record} />,
    },
    {
        dataIndex: ['shipment', 'quantityPerRoll'],
        title: 'Намотка',
        width: 80,
        render: (_value, record) => record.shipment?.quantityPerRoll || '—',
    },
    {
        dataIndex: ['shipment', 'bushing'],
        title: 'Втулка',
        width: 70,
        render: (_value, record) => record.shipment?.bushing || '—',
    },
    {
        dataIndex: ['shipment', 'materialRequirements'],
        title: 'Материал',
        width: 110,
        render: (_value, record) => (
            <MaterialColumnCell value={record.shipment?.materialRequirements || []} />
        ),
    },
    {
        dataIndex: ['shipment', 'shipment_positions'],
        key: 'floods',
        title: 'Ручьи',
        width: 70,
        render: (_value, record) => getShipmentFloods(record.shipment) ?? '—',
    },
    {
        key: 'printEndAt',
        title: 'Время окончания печати',
        width: 90,
        render: (_value, record) => <PrintEndTimeCell shipment={record.shipment} />,
    },
    {
        dataIndex: 'actions',
        title: '',
        width: 88,
        fixed: 'right',
        render: (_value, record) => <ActionsCell rewindJob={record} machines={machines} />,
    },
]
